import React from 'react';
import AllRoute from '../router'
import {ToastContainer} from 'react-toastify';
import { HelmetProvider } from 'react-helmet-async'; // 1. Bunu ekle
import 'react-toastify/dist/ReactToastify.css';

const App = () => { 

  return (
    <HelmetProvider> {/* 2. En dışı bununla sarla */}
        <div className="App" id='scrool'>
              <AllRoute/>
              <ToastContainer/>
        </div>
    </HelmetProvider>
  );
}

export default App;